import React, { useEffect } from 'react'
import {DragSource, DropArea} from "../../partials/DragAndDrop/compound-components";
import useDragAndDropContext from "../../partials/DragAndDrop/hooks/useDragAndDropContext";

const Target = (props) => {
    const {index, className, children} = props
    const {customDragLayer, allowSort, dndProps, source, target, style, dispatch} = useDragAndDropContext()
    const [unplaced, targetStates, dragData, manager] = dndProps


    const targetData = dragData.mergeTargetStateWithData(targetStates)[index]

    function handleDrop () {
        const action = {type:'handleDrop', package:arguments}
        dispatch(action)
    }
    function handleMove () {
        const action = {type:'handleMove', package:arguments}
        dispatch(action)        
    }
    function handleLimitReachedDrop () {
      const action = {type:'handleLimitReachedDrop', package:arguments}
      dispatch(action)        
    }
    

    //console.log("Target: className = ",className,className===undefined)
    return (<>
        {<DropArea
                data={targetData}
                key={targetData.k}
                onDrop={(item) => handleDrop(targetData, item)} // should this be 'index' or 'zone'
                onLimitReachedDrop={(item) => handleLimitReachedDrop(targetData, item)}
                style={style}
                className ={className}
                target={target}
              >

                {
                  dragData.mergeSourceStateWithData(targetData.dS).map( (item,i,allSources) => <DragSource
                    all={allSources}  
                    data={item}
                    key={item.k}
                    style={style}
                    source={source}
                    onMove={handleMove}
                  />)
                }
        </DropArea>}
    </>)
}
export default Target